import Axios from 'api/client';
import queryString from 'query-string';

export interface ActivityParams {
    type?: string;
    data?: object;
}

export interface UpdateActivityParams extends ActivityParams {
    activityId: number;
}

export interface ReassignActivityParams extends UpdateActivityParams {
    newContactId: number;
}

export interface FetchActivityParams extends ActivityParams {
    options: Record<string, any>;
}

export interface ReassignResourceParams {
    resourceId: number;
    resourceType: string | null;
    newContactId: number;
}

export const addNewActivity = (
    accountId: number,
    contactId: number,
    { data, type }: ActivityParams,
) =>
    Axios.post(`/accounts/${accountId}/contacts/${contactId}/activities`, {
        type,
        ...data,
    });
export const updateActivity = (
    accountId: number,
    contactId: number,
    { activityId, data }: UpdateActivityParams,
) => Axios.patch(`/accounts/${accountId}/contacts/${contactId}/activities/${activityId}`, data);

export const deleteActivity = (
    accountId: number,
    contactId: number,
    { activityId }: UpdateActivityParams,
) => Axios.delete(`/accounts/${accountId}/contacts/${contactId}/activities/${activityId}`);

export const fetchContactActivities = (
    accountId: number,
    contactId: number,
    { type, options }: FetchActivityParams,
) => {
    let url = `/accounts/${accountId}/contacts/${contactId}/activities?${queryString.stringify(
        options,
    )}`;
    if (type !== 'none') {
        url = `${url}&type=${type}`;
    }
    return Axios.get(url).then(response => response.data);
};

export const reassignActivity = (
    accountId: number,
    contactId: number,
    { activityId, newContactId }: ReassignActivityParams,
) =>
    Axios.patch(`/accounts/${accountId}/contacts/${contactId}/activities/${activityId}/reassign`, {
        contact_id: newContactId,
    });

export const reassignResource = (
    accountId: number,
    contactId: number,
    { resourceId, resourceType, newContactId }: ReassignResourceParams,
) =>
    Axios.patch(`/accounts/${accountId}/contacts/${contactId}/reassign-resource`, {
        contact_id: newContactId,
        resource_id: resourceId,
        resource_type: resourceType,
    });
